import React from 'react';
import StyledComponent from 'styled-components';

function Footer() {
  const bgColor = '#222';
  const textColor = '#FFF';
  const fixed = false;
  const Container = StyledComponent.div`
    .footer
    {
      background-color: ${bgColor};
      color: ${textColor} !important;
      position: ${fixed ? 'fixed' : 'relative'};
      bottom: 0;
      width: 100%;
      height: 60px;
    }
  `;

  return (
    <Container>
      <footer className="footer mt-auto py-3">
        <div className="container">Copyright 2025 Check In</div>
      </footer>
    </Container>
  );
}
export default Footer;
